(function () {
  'use strict';

  var TARGET_ID = 'snoozy-kaching-offer';
  var KACHING_SELECTOR = 'kaching-bundles-block';

  function alreadyTagged() {
    return !!document.getElementById(TARGET_ID);
  }

  function tagKaching() {
    if (alreadyTagged()) return true;
    var el = document.querySelector(KACHING_SELECTOR);
    if (!el) return false;
    el.id = TARGET_ID;
    return true;
  }

  if (tagKaching()) return;

  var observer = new MutationObserver(function () {
    if (tagKaching()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Kaching's block renders quickly if it's present at all; stop watching
  // after 15s so this doesn't run indefinitely on pages without it.
  setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
